import { useAppLayoutContext, useAppLayoutGutterSize } from './useAppLayoutContext';
import { useShouldRenderContentSidebarAtCurrentWidth } from './useShouldRenderContentSidebarAtCurrentWidth';

export interface ContentRowPaddingValues {
  readonly horizontalPadding: number;
  readonly paddingLeft: number | undefined;
}

type UseContentRowPadding = () => ContentRowPaddingValues;

/**
 * Calculates padding values for ContentRow based on layout context.
 *
 * Handles three scenarios:
 * 1. Explicit content padding removal - When layout explicitly requests no padding
 * 2. Pinned collapsible right rail - When sidebar is shown and pinned, only remove right padding
 * 3. Normal layout - Standard padding behavior
 */
export const useContentRowPadding: UseContentRowPadding = () => {
  const gutterSize = useAppLayoutGutterSize();
  const appLayoutContext = useAppLayoutContext();
  const isSidebarRendered = useShouldRenderContentSidebarAtCurrentWidth();
  const shouldRemoveContentPadding = appLayoutContext?.removeContentPadding;
  const hasPinnedCollapsibleRightRail = appLayoutContext?.pinnedCollapsibleRightRail && isSidebarRendered;

  let horizontalPadding: number;
  let paddingLeft: number | undefined;

  if (shouldRemoveContentPadding) {
    horizontalPadding = 0;
    paddingLeft = undefined;
  } else if (hasPinnedCollapsibleRightRail) {
    horizontalPadding = 0;
    paddingLeft = gutterSize;
  } else {
    horizontalPadding = gutterSize;
    paddingLeft = undefined;
  }

  return {
    horizontalPadding,
    paddingLeft,
  };
};
